import { Box, MenuItem, Select } from "@mui/material";
import axiosInstance from "../../../http-common";

export const convert_dd_mm_yy_to_Date = (date_string) => {
  // console.log(date_string);
  const [dd, mm, yy] = date_string.split("/").map((d) => parseInt(d));
  return new Date(yy, mm - 1, dd);
};

export const sample_types = [
  { label: "SFG(with micro)", value: "SFG(with micro)" },
  { label: "SFG(without micro)", value: "SFG(without micro)" },
  { label: "FP(with micro)", value: "FP(without micro)" },
  {
    label: "CB(urgent)",
    value: "CB(urgent)",
  },
  {
    label: "CB",
    value: "CB",
  },
  {
    label: "CB(additional)",
    value: "CB(additional)",
  },
];

export const date_time_string_to_date = (date_time_string) => {
  // console.log({ date_time_string, d: new Date(date_time_string) });
  if (!date_time_string) return date_time_string;
  if (date_time_string !== null) return new Date(date_time_string);
};

export const date_column_properties = {
  type: "date",
  valueGetter: ({ value }) => {
    if (typeof value === "object") return value;
    return value && convert_dd_mm_yy_to_Date(value);
  },
};

export const select_options = {
  test_status: [
    {
      label: "Pending",
      value: "P",
    },
    {
      label: "Under Test",
      value: "U",
    },
    {
      label: "Completed",
      value: "D",
    },
    {
      label: "OOS",
      value: "OOS",
    },
    {
      label: "OOT",
      value: "OOT",
    },
    {
      label: "Deviation",
      value: "Deviation",
    },
    {
      label: "Not Required",
      value: "N",
    },
  ],
  reviewer_remark_status: [
    {
      label: "Pending",
      value: "Pending",
    },
    {
      label: "Completed",
      value: "Completed",
    },
    // {
    //   "label": "Review",
    //   "value": "Review"
    // },
    {
      label: "OOS",
      value: "OOS",
    },
    {
      label: "OOT",
      value: "OOT",
    },
    {
      label: "Deviation",
      value: "Deviation",
    },
    // {
    //   "label": "Investigation",
    //   "value": "Investigation"
    // },
    // {
    //   "label": "Terminated",
    //   "value": "Terminated"
    // },
    {
      label: "Lab Event",
      value: "Lab Event",
    },
    {
      label: "QMS Impacted sample",
      value: "QMS Impacted sample",
    },
  ],

  remark_status: [
    {
      label: "Pending",
      value: "Pending",
    },
    {
      label: "QC Testing Completed",
      value: "QC Testing Completed",
    },
    {
      label: "Under Review",
      value: "Under Review",
    },
    {
      label: "Awaiting Approval",
      value: "Awaiting Approval",
    },
    {
      label: "Under UD",
      value: "Under UD",
    },
    {
      label: "UD Approved",
      value: "UD Approved",
    },
  ],
};

export const status_to_background_color_mapping = {
  D: "#00b050",
  N: "#FF0000",
  U: "#FFC000",
  warning: "#ffff07",
};

export const test_status_column_properties = {
  type: "singleSelect",
  valueOptions: [
    ...select_options.test_status,
    // { value: "P", label: "Pending" },
    // { value: "U", label: "Under Test" },
    // { value: "D", label: "Completed" },
    // { value: "N", label: "Not Required" },
  ],
};

const status_label_mapping = {
  P: "Pending",
  N: "Not Required",
  U: "Under Test",
  D: "Completed",
};

export const render_status_cell = (props) => {
  const { colDef, row } = props;
  const { field } = colDef;
  // console.log(field);
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        // padding: "10px",
        // margin: "10px",
        backgroundColor: status_to_background_color_mapping[row[field]],
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      <p className="text-sm p-2">{status_label_mapping[row[field]]}</p>
    </Box>
  );
};

export const status_remark_status_column_properties = {
  type: "singleSelect",
  valueOptions: [
    // ...select_options.remark_status
    { value: undefined, label: "Pending" },
    { value: "Under Review", label: "Under Review" },
    { value: "Under Test", label: "Under Test" },
    // { value: "Not Required", label: "Not Required" },
    { value: "Awaiting Approval", label: "Awaiting Approval" },
    { value: "Under UD", label: "Under UD" },
    { value: "QC Testing Completed", label: "QC Testing Completed" },
  ],
};

export const reviewer_remark_status_column_properties = {
  type: "singleSelect",
  valueOptions: [
    { value: "Pending", label: "Pending" },
    { value: "Completed", label: "Completed" },
    { value: "OOS", label: "OOS" },
    { value: "OOT", label: "OOT" },
    { value: "Deviation", label: "Deviation" },
    { value: "Lab Event", label: "Lab Event" },
    { value: "QMS Impacted sample", label: "QMS Impacted sample" },
  ],
};

export const RenderRemarkCell = ({ colDef, row, ...rest }) => {
  console.log({ row, rest });
  const { updateRows } = rest.api;

  const handleChange = async (e) => {
    const value = e.target.value;
    const batch_no = row?.batch_number;
    const remark = row?.remark;
    const material_type = row?.["Material Type"] || row?.["sample_type"];
    const _id = row?._id;
    var formdata = new FormData();
    formdata.append("batch_no", batch_no);
    formdata.append("remark", remark);
    formdata.append("reviewers_remark", value);
    formdata.append("_id", _id);
    try {
      const response = await axiosInstance.patch(
        `/v1/qc/reviewer_data/${material_type}/`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const { status } = response.data;

      if (status && status === "success") {
        updateRows([{ ...row, reviewers_remark: value }]);
        console.log("done!");
      }
      console.log(response.data);
    } catch (error) {
      console.error("error", error);
    }
  };
  return (
    <Box sx={{ width: "100%" }}>
      <Select
        sx={{ width: "100%" }}
        value={row.reviewers_remark}
        onChange={handleChange}
        size={"small"}
      >
        {reviewer_remark_status_column_properties.valueOptions.map(
          ({ value, label }, idx) => (
            <MenuItem key={`${row.id}-${value}-${label}-${idx}`} value={value}>
              {label}
            </MenuItem>
          )
        )}
      </Select>
    </Box>
  );
};

// obj for static columns
export const generateStaticColumns = (columnName) => {
  // console.log(testNames);
  return columnName.reduce((acc, columnName) => {
    acc[columnName] = {
      name: columnName,
      isDate: false,
      isSelect: false,
      isText: false,
      needsDateInput: false,
      visible: true,
      editable: false,
      field: columnName,
      headerName: columnName?.split("_")?.join(" "),
      width: 200,
    };
    return acc;
  }, {});
};

// making object for each test
export const generateTestColumns = (testNames) => {
  // console.log(testNames);
  return testNames.reduce((acc, testName) => {
    acc[testName] = {
      name: testName,
      type: "singleSelect",
      isDate: false,
      isSelect: false,
      isText: false,
      needsDateInput: false,
      visible: true,
      editable: false,
      // select_options: "test_status",
      field: testName,
      headerName: testName?.split("_")?.join(" "),
      width: 200,
      renderCell: render_status_cell,
    };
    return acc;
  }, {});
};
// generate editable columns
export const generateEditableColumns = (columnName) => {
  // console.log(testNames);
  return columnName.reduce((acc, columnName) => {
    acc[columnName] = {
      type: null,
      isDate: false,
      isSelect: true,
      isText: false,
      needsDateInput: false,
      visible: true,
      editable: false,
      select_options: "reviewer_remark_status",
      field: columnName,
      headerName: columnName?.split("_")?.join(" "),
      width: 200,
      ...reviewer_remark_status_column_properties,
      renderCell: RenderRemarkCell,
    };

    return acc;
  }, {});
};

// const testData = await getTestTypes();

// console.log(testData);
// export const reviewerGridColumns = await getReviewerHeaders();
